import React, { useState, useCallback } from 'react'
import { Grid } from '@mui/material'
// import { useState } from 'react'
import {
  SimpleForm,
  BooleanInput,
  TextInput,
  required,
  SelectInput,
  useNotify,
  useRedirect,
  useCreate,
} from 'react-admin'
// import dayjs from 'dayjs'
import { COMMON_FIELDS, SERVICES_FIELDS } from '../../providers/localization/constant'
import { CreateBase } from '../../components/base'
import { FormBottomToolbarWithPermission } from '../../components/form'

const PREFIX = 'resources.services'

const ServiceCreate: React.FC = () => {
  const notify = useNotify()
  const redirect = useRedirect()
  const [serviceDurationHours, setServiceDurationHours] = useState<string>('0')
  const [serviceDurationMinutes, setServiceDurationMinutes] = useState<string>('0')
  const validateServiceDuration = (): string | undefined => {
    const hours = parseInt(serviceDurationHours, 10)
    const minutes = parseInt(serviceDurationMinutes, 10)

    if (hours === 0 && minutes === 0) {
      return 'เวลาบริการไม่ถูกต้อง กรุณาเลือกใหม่'
    }

    return undefined // Return undefined for no validation error
  }

  const handleHoursChange = (event): void => {
    setServiceDurationHours(event.target.value as string)
  }

  const handleMinutesChange = (event): void => {
    setServiceDurationMinutes(event.target.value as string)
  }

  const onError = useCallback(
    (error): void => {
      if(error.response.data.code === '23505') {
        return notify('ra.validation.create_service_fail_by_key' || 'ra.validation.create_service_fail', { type: 'error' })
      }
     
      return notify(error ||'ra.validation.create_service_fail', { type: 'error' })
    },
    [notify],
  )
  const onSuccess = useCallback(async (): Promise<void> => {
    notify('ra.notification.create_service_success', { type: 'success' })
    redirect('list', 'services')
  }, [notify, redirect])
  const [create] = useCreate(undefined, undefined, { onError, onSuccess })

  const handleSubmit = (data): void => {
    create('services', { data })
  }
  return (
    <CreateBase
      title={`${PREFIX}.create.title`}
      listAction={{
        hasBackButton: true,
      }}
      // encType='application/json'
    >
      <SimpleForm
        onSubmit={handleSubmit}
        toolbar={<FormBottomToolbarWithPermission encType='application/json' />}
        // defaultValues={postDefaultValue}
      >
        <Grid container spacing={2} xs={12}>
          <Grid item xs={12} md={6}>
            <TextInput
              source='title_th'
              label={`${SERVICES_FIELDS}.title_th`}
              fullWidth
              validate={[required()]}
              // disabled={preventEdit}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextInput
              source='title_en'
              label={`${SERVICES_FIELDS}.title_en`}
              fullWidth
              validate={[required()]}
              // disabled={preventEdit}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <SelectInput
              fullWidth
              source='service_duration_hours'
              label={`${SERVICES_FIELDS}.service_duration_hours`}
              choices={[
                { id: '0', name: '0 ชั่วโมง' },
                { id: '1', name: '1 ชั่วโมง' },
                { id: '2', name: '2 ชั่วโมง' },
                { id: '3', name: '3 ชั่วโมง' },
                { id: '4', name: '4 ชั่วโมง' },
              ]}
              onChange={handleHoursChange}
              defaultValue={'0'}
              validate={[required(), validateServiceDuration]}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <SelectInput
              source='service_duration_minutes'
              label={`${SERVICES_FIELDS}.service_duration_minutes`}
              choices={[
                { id: '00', name: '0 นาที' },
                { id: '15', name: '15 นาที' },
                { id: '30', name: '30 นาที' },
                { id: '45', name: '45 นาที' },
              ]}
              defaultValue={'00'}
              onChange={handleMinutesChange}
              fullWidth
              validate={[required(), validateServiceDuration]}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextInput
              source='key'
              label={`${SERVICES_FIELDS}.key`}
              fullWidth
              validate={[required()]}
              // disabled={preventEdit}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <SelectInput
              source='type'
              label={`${SERVICES_FIELDS}.type_of_service.label`}
              choices={[
                { id: 'main', name: 'บริการ' },
                { id: 'other', name: 'บริการอื่นๆ' },
              ]}
              defaultValue={'main'}
              fullWidth
              validate={[required()]}
              sx={{ mt: 0 }}
            />
          </Grid>
          <Grid item xs={2}>
            <BooleanInput
              color='primary'
              source='is_active'
              label={`${COMMON_FIELDS}.status.label`}
            />
          </Grid>
        </Grid>

        {/* <Grid item xs={6}>
          <TextInput
            source='description_th'
            label={`${SERVICES_FIELDS}.description_th`}
            fullWidth
            multiline
            maxRows={4}
            validate={[required()]}
            // disabled={preventEdit}
          />
        </Grid>
        <Grid item xs={6}>
          <TextInput
            source='description_en'
            label={`${SERVICES_FIELDS}.description_en`}
            fullWidth
            multiline
            maxRows={4}
            validate={[required()]}
            // disabled={preventEdit}
          />
        </Grid> */}
      </SimpleForm>
    </CreateBase>
  )
}

export default ServiceCreate
